import { Component, OnInit, TemplateRef } from '@angular/core';
import { DialogComponent } from '@app/shared/dialog/dialog-component.directive';
import { isTranslatable, Translatable } from '@app/translate/models/translatable';
import { PortalError } from '@app/utils/error/portal-error';

export interface ErrorDialogInput {
  description?: Translatable | TemplateRef<any>;
  errors: PortalError[];
  title?: TemplateRef<any> | Translatable;
}

@Component({
  selector: 'portal-error-dialog',
  templateUrl: './error-dialog.component.html',
  styles: [],
  host: {
    class: 'error-dialog',
  },
  standalone: false,
})
export class ErrorDialogComponent
  extends DialogComponent<ErrorDialogInput, void>
  implements OnInit, ErrorDialogInput
{
  readonly description?: Translatable | TemplateRef<any>;
  readonly errors: PortalError[];
  readonly title?: TemplateRef<any> | Translatable;

  descriptionIsTranslatable: boolean;
  titleIsTranslatable: boolean;

  ngOnInit(): void {
    this.descriptionIsTranslatable = isTranslatable(this.description);
    this.titleIsTranslatable = isTranslatable(this.title);
  }
}
